const mutations = {
  GET_USER_INFO (state, getUserInfo) {
    state.getUserInfo = getUserInfo
    window.localStorage.setItem('getUserInfo', JSON.stringify(getUserInfo))
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js